import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-394888ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "area-clear" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "入力をクリア", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "section input-form" }
const _hoisted_8 = { class: "navigation" }
const _hoisted_9 = { class: "navigation-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 内容を確認 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthorNotification = _resolveComponent("AuthorNotification")!
  const _component_AuthorInfoVue = _resolveComponent("AuthorInfoVue")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AuthorNotification)
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputClear && _ctx.inputClear(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.inputClear && _ctx.inputClear(...args)), ["prevent"]), ["space","enter"])),
          class: "button-clear"
        }, _hoisted_6, 32)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AuthorInfoVue, {
          modelValue: _ctx.authorInfoData,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authorInfoData) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UserInfo, {
          modelValue: _ctx.contactInfoData,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactInfoData) = $event)),
          requiredCheck: _ctx.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AppButton, {
            onClick: _ctx.confirm,
            onKeydown: _withKeys(_withModifiers(_ctx.confirm, ["prevent"]), ["space","enter"]),
            styled: 'is-accent',
            buttonId: 'button-next'
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])
        ])
      ])
    ]),
    _createVNode(_component_ToPageTop)
  ], 64))
}